import React, { useEffect, useState } from 'react';
import { Route, useLocation, Redirect } from 'react-router-dom';
import { useUserContext } from '../../../context_providers/user_context/UserProvider';
import { useUserUpdaterProvider } from '../../../context_providers/user_context/UserUpdaterProvider';
import Unauthorized from './Unauthorized';
import SignUp from '../../../views/UserViews/sign_up/SignUp';
import { isRoleAccepted } from './AcceptedRoles';
import TransitionWrapper from '../../transition_wrapper/TransitionWrapper';
import { useAppVersionProvider } from '../../../context_providers/app_version_context/AppVersionProvider';
import { Box } from '@mui/material';
import { useBannerHeight } from '../../../context_providers/banner_context/BannerHeightContext';
import LoadingSpinner from '../../loading/LoadingSpinner';
import { Routes } from '../../../enums/Routes';

const ProtectedUserRoute = ({
  component: Component,
  requiredPermission,
  ...rest
}) => {
  const { userRole } = useUserUpdaterProvider();
  const {
    userExists,
    isSafeguardDev,
    isSafeguardManufacturingUser,
    safeguardView,
    isSafeguardAdmin,
  } = useUserContext();
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const { inMaintenance } = useAppVersionProvider();
  const location = useLocation();
  const { emergencyMapBoxPadding, defaultPageBoxPadding } = useBannerHeight();
  const [paddingToUse, setPaddingToUse] = useState(0);
  useEffect(() => {
    if (location.pathname === '/') {
      setPaddingToUse(emergencyMapBoxPadding);
    } else {
      setPaddingToUse(defaultPageBoxPadding);
    }
  }, [location.pathname, emergencyMapBoxPadding, defaultPageBoxPadding]);

  useEffect(() => {
    if (
      isSafeguardDev ||
      isSafeguardManufacturingUser ||
      isSafeguardAdmin ||
      (userExists !== null && userRole !== null)
    ) {
      setIsDataLoaded(true);
    }
  }, [
    userRole,
    userExists,
    isSafeguardDev,
    isSafeguardManufacturingUser,
    isSafeguardAdmin,
  ]);

  if (!isDataLoaded) return <LoadingSpinner />;
  if (
    inMaintenance &&
    !isSafeguardDev &&
    !isSafeguardManufacturingUser &&
    !isSafeguardAdmin
  )
    return null;
  if (userExists != null && !userExists) return <SignUp />;
  if (
    isSafeguardManufacturingUser &&
    !isSafeguardDev &&
    !isSafeguardAdmin &&
    safeguardView
  ) {
    return <Redirect to={Routes.MANUFACTURING} />;
  }
  if (
    isSafeguardDev ||
    isSafeguardManufacturingUser ||
    isSafeguardAdmin ||
    (userRole && isRoleAccepted(userRole))
  ) {
    return (
      <TransitionWrapper>
        <Box component="main" sx={{ pt: paddingToUse }}>
          <Route {...rest} render={(props) => <Component {...props} />} />
        </Box>
      </TransitionWrapper>
    );
  }
  return <Unauthorized />;
};

export default ProtectedUserRoute;
